import React from 'react';
import {LocationStates} from '../../../views/VerifyModalScreen/VerifyModalScreen';
import {IDENTITY_VERIFICATION_PHOTOS_QUALITY} from '../../../utils/constants';
import Webcam from '../../Webcam';
import styles from '../ConfirmIdentityTemplate.module.sass';
import {ActivityIndicator, Buttons} from './';

const videoConstraints = {
  facingMode: 'user',
};

const TakePhotoComponent = React.memo((props: any) => {
  const Content = React.memo(
    ({screenshot, webcamRef, activityIndicator, stateName, ...props}: any) => {
      const isSelfie = stateName === LocationStates.selfiePhoto;

      if (activityIndicator)
        return <ActivityIndicator activityIndicator={activityIndicator} />;
      if (screenshot) {
        return <img className={styles.screenshot} src={screenshot} alt="Front side" />;
      }

      return (
        <div style={{position: 'relative'}}>
          <Webcam
            ref={webcamRef}
            videoConstraints={isSelfie ? videoConstraints : null}
            screenshotQuality={IDENTITY_VERIFICATION_PHOTOS_QUALITY}
            {...props}
          />
        </div>
      );
    },
  );

  return (
    <>
      <Content
        screenshot={props.screenshot}
        webcamRef={props.webcamRef}
        activityIndicator={props.activityIndicator}
        stateName={props.stateName}
        onUserMedia={props.onUserMedia}
        minScreenshotW={props.minScreenshotW}
        minScreenshotH={props.minScreenshotH}
      />
      <Buttons
        screenshot={props.screenshot}
        onSend={props.onSend}
        onCapture={props.onCapture}
        isCaptureButtonDisabled={props.isCaptureButtonDisabled}
        onRetry={props.onRetry}
        disabled={props.disabled}
        withCapture={props.withCapture}
      />
    </>
  );
});

export {TakePhotoComponent};
